import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  Paper,
  Radio,
  RadioGroup,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import AuthService from "../../AuthService";
import BarraTitulo from "../Generico/BarraTitulo";
import ConfiguracaoEntregaBairro from "./configuracaoEntregaBairro";
import ConfiguracaoTaxa from "./configuracaoTaxa";

const ConfiguracaoFormatoEntrega = () => {
  const { enqueueSnackbar } = useSnackbar();
  const theme = useTheme();
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));
  const [empresa, setEmpresa] = useState(null);
  const [tipoEntrega, setTipoEntrega] = useState(null);
  const [formaRetirada, setFormaRetirada] = useState({});
  const isQuilometragem = tipoEntrega === "QUILOMETRAGEM";

  useEffect(() => {
    const service = new AuthService();
    service
      .get("/login/empresaLogada")
      .then((empresa) => {
        setEmpresa(empresa);
        setTipoEntrega(empresa.configuracaoEntrega);

        const form = JSON.parse(empresa.formaRetirada);
        let formaTemp = { formaRetiradaDelivery: "", formaRetiradaLocal: "" };

        form.forEach((e) => {
          if (e === "D")
            formaTemp = { ...formaTemp, formaRetiradaDelivery: "D" };
          if (e === "L") formaTemp = { ...formaTemp, formaRetiradaLocal: "L" };
          if (e === "C") formaTemp = { ...formaTemp, formaConsumirLocal: "C" };
        });

        setFormaRetirada(formaTemp);
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  const handleChange = (event) => {
    setTipoEntrega(event.target.value);

    const valorTipoEntrega = event.target.value;
    const copiaEmpresa = { ...empresa };
    copiaEmpresa.configuracaoEntrega = valorTipoEntrega;

    setEmpresa(copiaEmpresa);
  };

  const handleSaveEmpresa = (empresa) => {
    const service = new AuthService();
    service
      .post("/empresa", empresa)
      .then((resp) => {
        const profile = service.getProfile();
        profile.empresa = resp;
        localStorage.setItem("_profile", JSON.stringify(profile));
        enqueueSnackbar("Configuração salva com sucesso.", {
          variant: "success",
        });
      })
      .catch((err) => {
        enqueueSnackbar("Erro ao salvar configuração.", { variant: "error" });
        console.error(err);
      });
  };

  const salvar = () => {
    const configuracaoFormaRetirada = [
      formaRetirada.formaRetiradaLocal ? "L" : "",
      formaRetirada.formaRetiradaDelivery ? "D" : "",
      formaRetirada.formaConsumirLocal ? "C" : "",
    ];

    const copiaEmpresa = { ...empresa };
    copiaEmpresa.formaRetirada = JSON.stringify(configuracaoFormaRetirada);
    handleSaveEmpresa(copiaEmpresa);
  };

  const alterarConfiguracao = (event, formaRetiradaSelecionada) => {
    const { name, checked } = event.target;
    const value = checked ? formaRetiradaSelecionada : "";

    setFormaRetirada({ ...formaRetirada, [name]: value });
  };

  return (
    <>
      <BarraTitulo
        title="Taxas de entrega"
        subTitle="Configure as taxas de entrega conforme sua preferência"
      />
      <Paper>
        <Box padding="1rem 1.5rem">
          <FormGroup
            row
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Box>
              <Box
                gap={isTablet ? 1 : 2}
                display="flex"
                flexDirection={isTablet ? "column" : "row"}
                alignItems={isTablet ? "flex-start" : "center"}
              >
                <Typography>Como sua loja trabalha com as entrega:</Typography>

                <FormControl>
                  <RadioGroup row value={tipoEntrega} onChange={handleChange}>
                    <FormControlLabel
                      control={<Radio value="QUILOMETRAGEM" />}
                      label="Entrega por quilometragem"
                    />
                    <FormControlLabel
                      control={<Radio value="BAIRRO" />}
                      label="Entrega por bairro"
                    />
                  </RadioGroup>
                </FormControl>
              </Box>

              <Box
                gap={isTablet ? 0 : 4}
                display="flex"
                flexDirection={isTablet ? "column" : "row"}
                alignItems={isTablet ? "flex-start" : "center"}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formaRetirada.formaRetiradaLocal === "L"}
                      onChange={(event) => alterarConfiguracao(event, "L")}
                      name="formaRetiradaLocal"
                      color="secondary"
                    />
                  }
                  label="Permite retirar no local"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formaRetirada.formaRetiradaDelivery === "D"}
                      onChange={(event) => alterarConfiguracao(event, "D")}
                      name="formaRetiradaDelivery"
                      color="secondary"
                    />
                  }
                  label="Permite entregar no delivery"
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formaRetirada.formaConsumirLocal === "C"}
                      onChange={(event) => alterarConfiguracao(event, "C")}
                      name="formaConsumirLocal"
                      color="secondary"
                    />
                  }
                  label="Permite consumir no local"
                />
              </Box>
            </Box>
            <Grid
              size={{
                xs: 12,
                md: 12,
              }}
              sx={{ width: "100%", marginTop: isTablet ? "1rem" : "0rem" }}
            >
              <Button
                variant="contained"
                sx={{ height: "3.5rem", minWidth: "12rem" }}
                color="secondary"
                fullWidth
                onClick={salvar}
              >
                salvar
              </Button>
            </Grid>
          </FormGroup>
        </Box>
      </Paper>
      <Box mt={5}>
        {isQuilometragem ? <ConfiguracaoTaxa /> : <ConfiguracaoEntregaBairro />}
      </Box>
    </>
  );
};

export default ConfiguracaoFormatoEntrega;
